import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from 'react-apollo'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'react-css-themr'
import TouchBackend from 'react-dnd-touch-backend'
import { DragDropContextProvider as DragDropProvider } from 'react-dnd'
import 'material-design-icons/iconfont/material-icons.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'

import './styles/commons.scss'
import theme from './styles/theme'

import Main from 'modules/app/Main'
import { apolloClient, configureStore } from './base'

const rootEl = document.getElementById('root')
const store = configureStore()

ReactDOM.render(<Root currentApp={Main} />, rootEl)

function Root({ currentApp }) {
  return (
    <DragDropProvider backend={TouchBackend({ enableMouseEvents: true })}>
      <ApolloProvider client={apolloClient} store={store}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            {React.createElement(currentApp)}
          </BrowserRouter>
        </ThemeProvider>
      </ApolloProvider>
    </DragDropProvider>
  )
}

if (module.hot) {
  module.hot.accept('modules/app/Main', () => {
    // eslint-disable-next-line global-require
    const NextApp = require('modules/app/Main').default

    ReactDOM.render(<Root currentApp={NextApp} />, rootEl)
  })
}



// WEBPACK FOOTER //
// ./client/index.js